export enum AlertUrgency {
  Urgent = "urgent",
  Rare = "rare",
  Common = "common",
}

export enum AlertContentType {
  ReportWorthLook = "ReportWorthLook",
  Celebration = "Celebration",
  Growth = "Growth",
  ReviewStudent = "ReviewStudent",
  SystemMessages = "SystemMessages",
  PD = "PD",
}

export enum AlertType {
  ReassessStudent = "ReassessStudent",
  ReviewTestScoring = "ReviewTestScoring",
  StudentBadgeEarned = "StudentBadgeEarned",
  ReadingRiskFlagged = "ReadingRiskFlagged",
  StudentNotReadingOrEngaging = "StudentNotReadingOrEngaging",
  AssessmentHasReviewNeededYellowFlagging = "AssessmentHasReviewNeededYellowFlagging",
  SkillGapNeedsAttention = "SkillGapNeedsAttention",
  StudentSkillGapFilled = "StudentSkillGapFilled",
  LessonPlanFixNeeded = "LessonPlanFixNeeded",
  AssignmentRecommended = "AssignmentRecommended",
  LessonPlanAutoFix = "LessonPlanAutoFix",
}
